export enum StakingEnrollmentsLocators {
	cancelEnrollmentModalCancelButton = 'cancelEnrollCancelButton',
	cancelEnrollmentModalConfirmButton = 'cancelEnrollmentModalConfirmButton',
	stakingEnrollmentsClearButton = 'stakingEnrollmentsClearButton',
	stakingEnrollmentsApplyButton = 'stakingEnrollmentsApplyButton',
	stakingEnrollmentsCreatedAtField = 'stakingEnrollmentsCreatedAtField',
	stakingEnrollmentsStatusField = 'stakingEnrollmentsStatusField',
	stakingEnrollmentsSearchIconButton = 'stakingEnrollmentsSearchIconButton',
	stakingEnrollmentsSearchField = 'stakingEnrollmentsSearchField',
}
